/* Monsieur Chasteté : quiz Sissy, portée limitée à sa section Shopify. */
(function () {
  "use strict";

const questions = [
  {
    title: "Quand vous imaginez jouer une sissy, qu’avez-vous le plus envie d’essayer ?",
    options: [
      { id: "character", title: "Créer mon personnage", detail: "Je choisis d’abord son allure, sans scénario précis." },
      { id: "princess", title: "Être choyée comme une princesse", detail: "Je reçois de l’attention et de la douceur dans ce rôle.", profile: "princesse" },
      { id: "maid", title: "Jouer la soubrette", detail: "Je m’imagine dans un rôle où je rends service.", profile: "soubrette" },
      { id: "guided", title: "Me laisser guider", detail: "Une autre personne choisit la suite, dans les limites fixées ensemble.", profile: "soumise" },
      { id: "humiliation", title: "Jouer une scène humiliante", detail: "Je suis ridiculisée dans une scène que j’ai choisie.", profile: "humiliee" },
      { id: "other", title: "J’ai une autre idée", detail: "Une envie précise qui ne figure pas dans ces propositions.", discreet: true }
    ]
  },
  {
    title: "Quelle allure féminine aimeriez-vous donner à ce personnage ?",
    options: [
      { id: "neat", title: "Une tenue soignée", detail: "Je choisis des détails qui me plaisent, sans chercher à en faire trop.", profile: "coquette" },
      { id: "sexy", title: "Un look très sexy", detail: "J’assume une allure voyante et provocante.", profile: "bimbo" },
      { id: "princess", title: "Une allure de princesse", detail: "J’ai envie d’une robe et d’accessoires qui évoquent ce rôle.", profile: "princesse" },
      { id: "maid", title: "Une tenue de soubrette", detail: "Un tablier ou d’autres détails me plaisent dans ce costume.", profile: "soubrette" },
      { id: "little", title: "La tenue compte peu", detail: "Je m’intéresse davantage à ce que je ferai qu’à mes vêtements." }
    ]
  },
  {
    title: "En dehors des vêtements, qu’est-ce qui vous aiderait à entrer dans le rôle ?",
    options: [
      { id: "name", title: "Un prénom choisi", detail: "Je l’utilise dès que je commence à jouer." },
      { id: "posture", title: "Une voix ou une posture", detail: "Je m’amuse à parler ou à me tenir autrement." },
      { id: "phrase", title: "Une phrase de départ", detail: "Je prononce quelques mots précis pour commencer." },
      { id: "nothing", title: "Aucun détail précis", detail: "Je peux entrer dans le rôle sans rituel." }
    ]
  },
  {
    title: "Si quelqu’un jouait avec vous, qu’aimeriez-vous de sa part ?",
    options: [
      { id: "outfit", title: "Qu’on remarque ma tenue", detail: "Un compliment sur les détails que j’ai choisis me ferait plaisir.", profile: "coquette" },
      { id: "sexy", title: "Qu’on me trouve très sexy", detail: "J’aime attirer le regard de l’autre avec mon allure.", profile: "bimbo" },
      { id: "cherished", title: "Qu’on me choye", detail: "Des gestes doux et des compliments me feraient plaisir.", profile: "princesse" },
      { id: "humiliation", title: "Qu’on m’humilie dans le jeu", detail: "Des moqueries choisies ensemble feraient partie du plaisir.", profile: "humiliee" },
      { id: "solo", title: "Je préfère jouer en solo", detail: "Ce personnage me plaît aussi sans partenaire." }
    ]
  },
  {
    title: "Une fois dans ce personnage, qu’auriez-vous envie de faire ?",
    options: [
      { id: "mirror", title: "Me préparer devant un miroir", detail: "Je peaufine mon allure jusqu’à me plaire.", profile: "coquette" },
      { id: "seduce", title: "Jouer à séduire", detail: "Je prends la pose ou je danse dans ce rôle.", profile: "bimbo" },
      { id: "task", title: "Faire une petite tâche", detail: "Je prépare une boisson ou range une pièce en jouant la soubrette.", profile: "soubrette" },
      { id: "instruction", title: "Suivre une consigne", detail: "Je fais ce que l’autre me demande dans un jeu décidé ensemble.", profile: "soumise" },
      { id: "moment", title: "Simplement profiter du moment", detail: "Je prends le temps de voir comment je me sens dans ce rôle." }
    ]
  },
  {
    title: "Comment aimeriez-vous décider de la suite du jeu ?",
    options: [
      { id: "plan", title: "Je prépare mon scénario", detail: "Je sais dès le départ ce que j’ai envie d’essayer." },
      { id: "together", title: "Nous décidons ensemble", detail: "Chacun propose ce qu’il aimerait faire ensuite." },
      { id: "led", title: "L’autre mène le jeu", detail: "Je lui laisse choisir la suite dans les limites prévues.", profile: "soumise" },
      { id: "improvise", title: "Je préfère improviser", detail: "Je vois sur le moment ce qui me plaît." }
    ]
  },
  {
    title: "Quelle place auraient les taquineries ou l’humiliation dans ce jeu ?",
    options: [
      { id: "none", title: "Aucune", detail: "Je ne souhaite ni taquineries ni humiliation." },
      { id: "teasing", title: "Des taquineries légères", detail: "On plaisante, sans chercher à m’humilier." },
      { id: "humiliation", title: "Une humiliation choisie", detail: "Cela m’attire si les mots et les limites sont fixés.", profile: "humiliee" },
      { id: "uncertain", title: "Je ne sais pas encore", detail: "J’aimerais d’abord découvrir ce qui me convient." }
    ]
  },
  {
    title: "Quelle place aimeriez-vous donner à une cage de chasteté dans ce jeu ?",
    options: [
      { id: "solo", title: "La porter pour moi", detail: "J’aimerais l’intégrer à mon jeu en solo." },
      { id: "shared", title: "Partager le contrôle", detail: "J’aimerais fixer les règles et la gestion des clés avec un partenaire." },
      { id: "character", title: "Compléter mon personnage", detail: "Sa présence et son apparence feraient partie du rôle que j’imagine." },
      { id: "no-cage", title: "Pas de cage pour le moment", detail: "Je préfère découvrir ce personnage autrement." }
    ]
  }
];

const profileOrder = ["coquette", "bimbo", "princesse", "soubrette", "soumise", "humiliee"];
const profiles = {
  coquette: {
    name: "La sissy coquette",
    alt: "Personnage coquet ajustant une boucle d’oreille devant un miroir",
    short: "Prendre plaisir à composer mon allure",
    description: "Vous aimez choisir une allure féminine qui vous plaît et en soigner les détails. Se préparer, essayer et ajuster font partie du plaisir. Ce moment peut vous plaire même si personne d’autre ne voit le résultat."
  },
  bimbo: {
    name: "La sissy bimbo",
    alt: "Personnage au maquillage affirmé dans une tenue glamour framboise et noire",
    short: "Oser une allure très sexy et jouer à séduire",
    description: "Vous aimez imaginer un personnage au look sexy et voyant. Prendre la pose, jouer à séduire ou attirer les regards fait partie de ce qui vous plaît. Vous pouvez essayer cette allure le temps d’une scène, à votre façon."
  },
  princesse: {
    name: "La sissy princesse",
    alt: "Personnage en robe de princesse recevant une rose",
    short: "Être choyée dans ce personnage",
    description: "Vous aimez jouer une princesse qu’on entoure d’attention. Une robe, un surnom ou quelques gestes doux peuvent vous aider à entrer dans ce rôle."
  },
  soubrette: {
    name: "La sissy soubrette",
    alt: "Personnage en tenue de soubrette passant le balai",
    short: "Jouer à rendre service",
    description: "Vous aimez jouer un personnage féminin qui rend service : servir une boisson, préparer une pièce ou accomplir une autre petite tâche. Ce rôle peut se jouer en solo ou à deux. Vous choisissez si l’autre personne dirige aussi le jeu."
  },
  soumise: {
    name: "La sissy soumise",
    alt: "Personnage acceptant une carte de consigne tendue par un partenaire",
    short: "Suivre des consignes dans un jeu choisi ensemble",
    description: "Vous aimez qu’une autre personne mène le jeu et vous propose des consignes. Vous décidez ensemble des limites, puis vous prenez plaisir à suivre sa direction."
  },
  humiliee: {
    name: "La sissy humiliée",
    alt: "Personnage en tenue féminine avec un collier de mode et une carte de jeu",
    short: "Une humiliation choisie",
    description: "Vous aimez imaginer un personnage que l’on tourne en dérision avec votre accord. Un surnom ou une moquerie peuvent vous plaire si vous avez choisi les mots et fixé les limites du jeu.",
    soloDescription: "Vous aimez imaginer une scène où votre personnage est tourné en dérision. Vous choisissez vous-même les mots, le déroulement et les limites de cette fiction."
  }
};

function getOption(index, value) {
  return questions[index].options.find(option => option.id === value);
}

// Résultat pur : les questions passées sont null. L'ordre de profileOrder
// contrôle seulement la présentation, jamais l'attribution en cas d'égalité.
function calculateResult(answers) {
  const scores = Object.fromEntries(profileOrder.map(key => [key, 0]));
  for (let index = 0; index < questions.length; index += 1) {
    const option = getOption(index, answers[index]);
    if (option?.profile) scores[option.profile] += 1;
  }
  const humiliationEligible = answers[6] === "humiliation" &&
    (answers[0] === "humiliation" || answers[3] === "humiliation");
  if (!humiliationEligible) scores.humiliee = 0;
  const highest = Math.max(...Object.values(scores));
  const leaders = profileOrder.filter(key => scores[key] === highest && highest > 0);
  const otherIdea = answers[0] === "other";
  let kind;
  if (highest >= 2) kind = leaders.length === 1 ? "profile" : leaders.length === 2 ? "two-profiles" : "many-profiles";
  else if (highest === 1) kind = leaders.length === 1 ? "one-piste" : "many-pistes";
  else kind = otherIdea ? "other-idea" : "open";

  const trends = kind === "profile" && highest === 3
    ? profileOrder.filter(key => scores[key] === 2)
    : [];
  return {
    kind, scores, leaders, trends, otherIdea, highest,
    humiliationUncertain: answers[0] === "humiliation" && answers[3] === "humiliation" && answers[6] === "uncertain",
    solo: answers[3] === "solo",
    detail: answers[2] && answers[2] !== "nothing" ? getOption(2, answers[2])?.title : null,
    detailId: answers[2] && answers[2] !== "nothing" ? answers[2] : null,
    noCage: answers[7] === "no-cage"
  };
}

function escapeHtml(value) {
  return String(value).replace(/[&<>"']/g, char => ({
    "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;"
  })[char]);
}


const displayName = key => profiles[key].name.replace(/^La sissy /, "");
const names = keys => keys.map(displayName).join(", ");

// La question 3 personnalise seulement le premier pas proposé : elle ne
// contribue à aucun score. Sans profil choisi, l'idée reste volontairement
// ouverte pour ne pas attribuer un rôle que les réponses ne désignent pas.
const firstSteps = {
  coquette: {
    name: "Choisissez un prénom, puis présentez-vous devant le miroir en ajustant un détail de votre tenue.",
    posture: "Essayez une pose devant le miroir et regardez si elle met en valeur les détails de votre tenue.",
    phrase: "Trouvez une phrase pour présenter votre tenue et prononcez-la devant le miroir."
  },
  bimbo: {
    name: "Choisissez un prénom pour ce personnage, puis prononcez-le devant le miroir en prenant la pose.",
    posture: "Essayez une pose assurée ou une voix plus affirmée, le temps d’une courte scène.",
    phrase: "Préparez une phrase de séduction qui vous amuse et essayez-la en prenant la pose."
  },
  princesse: {
    name: "Choisissez un prénom de princesse et dites-le à voix haute en essayant votre tenue.",
    posture: "Tenez-vous bien droite ou prenez une voix douce, puis voyez si cela vous aide à jouer la princesse.",
    phrase: "Choisissez une phrase qui vous fait entrer dans votre rôle de princesse et dites-la à voix haute."
  },
  soubrette: {
    name: "Choisissez un prénom pour votre personnage et utilisez-le en accomplissant une petite tâche.",
    posture: "Essayez une autre voix ou une autre façon de vous tenir pendant une petite tâche, comme servir une boisson.",
    phrase: "Inventez une phrase pour annoncer la petite tâche que votre personnage va accomplir."
  },
  soumise: {
    name: "Choisissez un prénom pour ce rôle et utilisez-le au début d’une scène où vous suivez une consigne choisie.",
    posture: "Essayez une autre voix ou une autre façon de vous tenir quand vous suivez une consigne choisie.",
    phrase: "Choisissez une phrase qui marque le début du jeu, puis prononcez-la avant de suivre une consigne choisie."
  },
  humiliee: {
    name: "Choisissez un prénom et essayez-le dans une scène fictive dont vous avez fixé les mots et les limites.",
    posture: "Essayez une façon de vous tenir ou de parler pendant une scène de moquerie que vous avez choisie.",
    phrase: "Écrivez une réplique que vous aimeriez prononcer dans une scène de moquerie choisie."
  },
  open: {
    name: "Choisissez un prénom pour le personnage que vous imaginez et essayez-le à voix haute.",
    posture: "Essayez une voix ou une façon de vous tenir qui vous plaît dans ce personnage.",
    phrase: "Choisissez une première phrase pour ce personnage et essayez-la à voix haute."
  }
};

function firstStepFor(result, profileKey = null) {
  const suggestions = profileKey === null ? firstSteps.open : firstSteps[profileKey];
  return suggestions?.[result.detailId] || null;
}

function updateFirstStep(container, result, profileKey = null) {
  const note = container.querySelector("[data-first-step]");
  if (!note) return;
  const suggestion = firstStepFor(result, profileKey);
  note.hidden = !suggestion;
  note.querySelector("[data-first-step-text]").textContent = suggestion || "";
}

function imagePath(key, imageURLs) {
  return imageURLs[key] || "";
}

function imageMarkup(key, imageURLs, decorative = false) {
  const url = imagePath(key, imageURLs);
  if (!url) return "";
  return `<img class="result-card__image" src="${escapeHtml(url)}" alt="${decorative ? "" : escapeHtml(profiles[key].alt)}" loading="lazy">`;
}

function resultCard(key, result, imageURLs, small = false, badge = "", labelOnly = false) {
  const profile = profiles[key];
  const description = small ? profile.short : key === "humiliee" && result.solo
    ? profile.soloDescription : profile.description;
  return `<article class="result-card${small ? " result-card--small" : ""}" data-profile="${escapeHtml(key)}">
    <div class="result-card__content">${badge ? `<span class="result-card__badge">${escapeHtml(badge)}</span>` : ""}<h3>${escapeHtml(profile.name)}</h3>${labelOnly ? "" : `<p>${escapeHtml(description)}</p>`}</div>
    ${imageMarkup(key, imageURLs)}
  </article>`;
}

function renderResultContent(result, imageURLs = {}) {
  const { kind, leaders } = result;
  let html = "";
  if (kind === "profile") {
    html += `<h2 class="result-title" data-result-title tabindex="-1">Votre profil : ${escapeHtml(profiles[leaders[0]].name)}</h2>`;
    html += `<div class="result-cards result-cards--featured">${resultCard(leaders[0], result, imageURLs)}${result.trends.length === 1 ? resultCard(result.trends[0], result, imageURLs, false, "Autre tendance") : ""}</div>`;
    if (result.trends.length > 1) html += `<p class="result-note">D’autres facettes ressortent également : <strong>${escapeHtml(names(result.trends))}</strong>. Selon la scène, vous pourriez avoir envie d’explorer l’une ou l’autre.</p>`;
  } else if (kind === "two-profiles") {
    html += `<h2 class="result-title" data-result-title tabindex="-1">Deux profils à égalité</h2><p class="result-intro">Vos réponses se partagent entre <strong>${escapeHtml(displayName(leaders[0]))}</strong> et <strong>${escapeHtml(displayName(leaders[1]))}</strong>. Vous pouvez essayer ces deux façons de jouer sans devoir en choisir une seule.</p>`;
    html += `<div class="result-cards result-cards--featured">${leaders.map(key => resultCard(key, result, imageURLs)).join("")}</div>`;
  } else if (kind === "many-profiles") {
    html += `<h2 class="result-title" data-result-title tabindex="-1">Plusieurs profils à égalité</h2><p class="result-intro">Plusieurs envies ressortent à égalité : <strong>${escapeHtml(names(leaders))}</strong>. Vous pouvez les explorer sans chercher à en choisir une tout de suite.</p>`;
    html += `<div class="result-cards result-cards--compact">${leaders.map(key => resultCard(key, result, imageURLs, true, "", true)).join("")}</div>`;
  } else if (kind === "one-piste") {
    html += `<h2 class="result-title" data-result-title tabindex="-1">Une piste à explorer : ${escapeHtml(displayName(leaders[0]))}</h2><p class="result-intro">Une de vos réponses évoque ce rôle, mais les autres ne le confirment pas encore. Vous pouvez l’essayer si cette idée vous plaît.</p>`;
    html += `<div class="result-cards result-cards--compact">${resultCard(leaders[0], result, imageURLs, true, "Piste à explorer")}</div>`;
  } else if (kind === "many-pistes") {
    html += `<h2 class="result-title" data-result-title tabindex="-1">Plusieurs pistes à explorer</h2><p class="result-intro">Vos réponses évoquent ces rôles sans en privilégier un : <strong>${escapeHtml(names(leaders))}</strong>. Lequel aimeriez-vous essayer en premier ?</p>`;
    html += `<div data-piste-decision><p class="tie-prompt">Si vous le souhaitez, choisissez une première piste à essayer :</p><div class="result-cards result-cards--compact">${leaders.map(key => `<button type="button" class="tie-card" data-piste="${key}" aria-pressed="false" aria-label="Essayer d’abord ${escapeHtml(profiles[key].name)}">${imageMarkup(key, imageURLs, true)}<span><em class="tie-card__badge">Piste à explorer</em><strong>${escapeHtml(profiles[key].name)}</strong><small>${escapeHtml(profiles[key].short)}</small></span></button>`).join("")}</div><button data-keep-pistes class="button button-outline" type="button">Je préfère garder ces pistes</button><p data-piste-choice class="result-note" role="status" hidden></p></div>`;
  } else if (kind === "other-idea") {
    html += `<h2 class="result-title" data-result-title tabindex="-1">Une autre envie à explorer</h2><p class="result-intro">Vous avez une idée en tête qui ne figurait pas dans les propositions. Gardez cette idée comme point de départ.</p>`;
  } else {
    html += `<h2 class="result-title" data-result-title tabindex="-1">Vos envies sont encore à explorer</h2><p class="result-intro">Vos réponses ne désignent pas encore de profil parmi ceux proposés. Gardez les idées qui vous ont plu et revenez au quiz quand vous voudrez.</p>`;
  }

  if (result.humiliationUncertain) html += `<p class="result-note">Deux de vos réponses évoquent l’humiliation. Vous avez aussi indiqué ne pas savoir encore quelle place lui donner ; vous pouvez garder cette idée comme piste.</p>`;
  if (result.otherIdea && kind !== "other-idea") html += `<p class="result-note">Vous avez aussi indiqué une autre envie. Ce résultat décrit seulement les choix proposés qui vous ont parlé.</p>`;
  if (result.detailId) {
    const immediateProfile = ["profile", "one-piste"].includes(kind) ? leaders[0] : null;
    const deferred = ["two-profiles", "many-profiles", "many-pistes"].includes(kind);
    const firstStep = deferred ? null : firstStepFor(result, immediateProfile);
    html += `<p class="result-note" data-first-step role="status"${firstStep ? "" : " hidden"}><strong>Une idée pour commencer :</strong> <span data-first-step-text>${firstStep ? escapeHtml(firstStep) : ""}</span></p>`;
  }
  return html;
}

const radarProfiles = [
  { key: "coquette", label: "Coquette" },
  { key: "bimbo", label: "Bimbo" },
  { key: "princesse", label: "Princesse" },
  { key: "soubrette", label: "Soubrette" },
  { key: "soumise", label: "Soumise" },
  { key: "humiliee", label: "Humiliée" }
];

const RADAR_MAX = 3; // Chacun des six profils a trois occasions de marquer.
const RADAR_CENTER = { x: 370, y: 270 };
const RADAR_RADIUS = 180;

function radarPoint(axis, level, radius = RADAR_RADIUS) {
  const angle = axis * Math.PI / 3;
  const distance = (level / RADAR_MAX) * radius;
  return {
    x: RADAR_CENTER.x + Math.sin(angle) * distance,
    y: RADAR_CENTER.y - Math.cos(angle) * distance
  };
}

function radarCoords(point) {
  return `${point.x.toFixed(2)},${point.y.toFixed(2)}`;
}

function normalizedRadarScores(scores) {
  if (scores === null || typeof scores !== "object") {
    throw new TypeError("renderRadar attend les scores validés du résultat.");
  }
  return radarProfiles.map(({ key }) => {
    const score = scores[key];
    if (!Number.isInteger(score) || score < 0 || score > RADAR_MAX) {
      throw new RangeError(`Score invalide pour ${key} : attendu de 0 à ${RADAR_MAX}.`);
    }
    return score;
  });
}

// Renvoie une chaîne HTML pouvant être insérée dans le résultat :
// resultContainer.insertAdjacentHTML("beforeend", renderRadar(result.scores));
// L'image SVG est décorative pour les lecteurs d'écran ; les six valeurs sont
// reprises intégralement dans la liste sémantique située juste en dessous.
function renderRadar(scores) {
  const values = normalizedRadarScores(scores);
  const ringMarkup = Array.from({ length: RADAR_MAX }, (_, index) => {
    const level = index + 1;
    const polygon = radarProfiles.map((_, axis) => radarCoords(radarPoint(axis, level))).join(" ");
    const marker = radarPoint(0, level);
    return `<polygon class="radar-ring" points="${polygon}"/><text class="radar-ring-label" x="${marker.x + 12}" y="${marker.y + 5}">${level}</text>`;
  }).join("");

  const axisMarkup = radarProfiles.map((profile, axis) => {
    const end = radarPoint(axis, RADAR_MAX);
    const label = radarPoint(axis, RADAR_MAX, RADAR_RADIUS + 42);
    const side = Math.sin(axis * Math.PI / 3);
    const anchor = side > .4 ? "start" : side < -.4 ? "end" : "middle";
    const textY = label.y + (axis === 0 ? -2 : axis === 3 ? 10 : 5);
    return `<line class="radar-axis" x1="${RADAR_CENTER.x}" y1="${RADAR_CENTER.y}" x2="${end.x.toFixed(2)}" y2="${end.y.toFixed(2)}"/><text class="radar-axis-label" x="${label.x.toFixed(2)}" y="${textY.toFixed(2)}" text-anchor="${anchor}">${profile.label}</text>`;
  }).join("");

  const hasPoint = values.some(value => value > 0);
  const shape = hasPoint
    ? `<polygon class="radar-area" points="${values.map((score, axis) => radarCoords(radarPoint(axis, score))).join(" ")}"/>${values.map((score, axis) => {
      if (score === 0) return ""; // Évite six marqueurs superposés au centre.
      const point = radarPoint(axis, score);
      return `<circle class="radar-point" cx="${point.x.toFixed(2)}" cy="${point.y.toFixed(2)}" r="6"/>`;
    }).join("")}`
    : `<circle class="radar-origin" cx="${RADAR_CENTER.x}" cy="${RADAR_CENTER.y}" r="4"/>`;

  const list = radarProfiles.map((profile, index) =>
    `<li><span>${profile.label}</span><strong>${values[index]} / ${RADAR_MAX}</strong></li>`
  ).join("");
  return `<section class="radar-card" aria-label="Vos réponses dans ce quiz">
    <h2>Vos réponses dans ce quiz</h2>
    <p>Chaque axe montre les points retenus pour un profil, sur trois possibilités.</p>
    <svg class="radar-svg" viewBox="0 0 740 540" aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg">
      ${ringMarkup}${axisMarkup}${shape}
    </svg>
    ${hasPoint ? "" : '<p class="radar-empty">Aucun point retenu pour ces six profils.</p>'}
    <ul class="radar-values" aria-label="Points retenus par profil">${list}</ul>
    <p class="radar-note">Ce graphique résume vos réponses, pas votre personnalité. Un zéro signifie qu’aucune réponse n’a été retenue pour cet axe.</p>
  </section>`;
}


function productProfileChoices(result) {
  if (result.kind === "two-profiles" || result.kind === "many-profiles") return result.leaders;
  if (result.kind === "profile" && result.trends.length === 1) return [result.leaders[0], result.trends[0]];
  return [];
}

function selectedProductCards(root, result, chosenProfile = null) {
  const selected = [];
  const usedIds = new Set();
  function addFrom(profileKey) {
    const template = Array.from(root.querySelectorAll("template[data-products-for]"))
      .find(element => element.dataset.productsFor === profileKey);
    if (!template) return;
    for (const card of template.content.querySelectorAll("[data-product-card]")) {
      if (selected.length >= 2) break;
      const id = card.dataset.productId;
      if (!id || usedIds.has(id) || card.dataset.productAvailable === "false" || card.hasAttribute("hidden")) continue;
      usedIds.add(id);
      const cloned = card.cloneNode(true);
      cloned.dataset.productSource = profileKey;
      selected.push(cloned);
    }
  }
  // Un choix explicite prime sur les deux produits de repli. Les résultats
  // mixtes gardent les produits génériques jusqu'au choix d'une piste.
  const profileKey = chosenProfile || (["profile", "one-piste"].includes(result.kind)
    ? result.leaders[0] : null);
  if (profileKey && profileOrder.includes(profileKey)) addFrom(profileKey);
  if (selected.length < 2) addFrom("fallback");
  return selected;
}

function renderProductChooser(root, result) {
  const chooser = root.querySelector("[data-products-chooser]");
  const choices = productProfileChoices(result);
  chooser.replaceChildren();
  chooser.hidden = choices.length === 0;
  if (!choices.length) return;
  const prompt = document.createElement("p");
  prompt.textContent = "Choisissez un profil pour voir les modèles proposés :";
  chooser.append(prompt);
  const group = document.createElement("div");
  group.className = "mc-sissy__profile-choices";
  group.setAttribute("role", "group");
  group.setAttribute("aria-label", "Choix du profil pour les cages proposées");
  for (const key of choices) {
    const button = document.createElement("button");
    button.type = "button";
    button.className = "mc-sissy__profile-choice";
    button.dataset.chooseProductProfile = key;
    button.textContent = profiles[key].name;
    button.setAttribute("aria-pressed", result.kind === "profile" && key === result.leaders[0] ? "true" : "false");
    group.append(button);
  }
  chooser.append(group);
}

function renderProducts(root, result, chosenProfile = null) {
  const title = root.querySelector("[data-products-title]");
  const intro = root.querySelector("[data-products-intro]");
  const grid = root.querySelector("[data-products-grid]");
  const empty = root.querySelector("[data-products-empty]");
  const activeProfile = chosenProfile || (["profile", "one-piste"].includes(result.kind) ? result.leaders[0] : null);
  const cards = selectedProductCards(root, result, activeProfile);
  grid.replaceChildren(...cards);
  const complete = cards.length === 2;
  const sourceCount = activeProfile ? cards.filter(card => card.dataset.productSource === activeProfile).length : 0;
  title.textContent = complete ? "Deux modèles de cages à découvrir" : cards.length === 1
    ? "Un modèle de cage à découvrir" : "Des cages à découvrir";
  const mixed = productProfileChoices(result).length > 0 || result.kind === "many-pistes";
  const defaultIntro = cards.length === 0
    ? "Aucun modèle n’est disponible ici pour le moment ; vous pouvez parcourir la collection."
    : mixed && !activeProfile
    ? "Choisissez une piste pour voir les modèles proposés. En attendant, voici d’autres modèles disponibles sur le site."
    : activeProfile && sourceCount === 0
      ? "Voici des modèles disponibles à découvrir sur le site."
      : sourceCount === 2
        ? `Voici deux modèles associés au profil ${displayName(activeProfile)}.`
        : sourceCount === 1
          ? `Voici un modèle associé au profil ${displayName(activeProfile)}${cards.length === 2 ? ", complété par un autre disponible sur le site" : ""}.`
        : "Voici d’autres modèles disponibles sur le site pour poursuivre votre découverte.";
  intro.textContent = result.noCage && cards.length
    ? `Vous préférez explorer ce rôle sans cage pour le moment. Si cela vous tente plus tard, ${defaultIntro.charAt(0).toLowerCase()}${defaultIntro.slice(1)}`
    : result.noCage
      ? "Vous préférez explorer ce rôle sans cage pour le moment. Si cela vous tente plus tard, vous pourrez parcourir la collection."
      : defaultIntro;
  empty.textContent = cards.length === 1
    ? "Un seul modèle disponible est présenté pour le moment. Vous pouvez parcourir la collection pour en comparer d’autres."
    : "Aucun modèle n’est disponible ici pour le moment. Vous pouvez parcourir la collection ou faire le test de choix de cage.";
  empty.hidden = complete;
}

function initQuiz(root) {
  if (!root || root.dataset.mcSissyInitialized === "true") return;
  const pick = selector => root.querySelector(selector);
  const entry = pick("[data-entry]");
  const quiz = pick("[data-quiz]");
  const resultView = pick("[data-result]");
  const form = pick("[data-form]");
  const slot = pick("[data-question]");
  const error = pick("[data-error]");
  const back = pick("[data-back]");
  const skip = pick("[data-skip]");
  const next = pick("[data-next]");
  const start = pick("[data-start]");
  const resultContent = pick("[data-result-content]");
  const productChooser = pick("[data-products-chooser]");
  const restart = pick("[data-restart]");
  const imagesNode = pick("[data-profile-images]");
  const required = [entry, quiz, resultView, form, slot, error, back, skip, next, start, resultContent, productChooser,
    restart, pick("[data-progress-label]"), pick("[data-progress-fraction]"), pick("[data-progress]"),
    pick("[data-instruction]"), pick("[data-radar]"), pick("[data-products-title]"),
    pick("[data-products-intro]"), pick("[data-products-grid]"), pick("[data-products-empty]"), imagesNode];
  if (required.some(element => !element)) return;
  let imageURLs = {};
  try { imageURLs = JSON.parse(imagesNode.textContent || "{}"); } catch (error) { imageURLs = {}; }
  if (imageURLs === null || typeof imageURLs !== "object") imageURLs = {};
  // Les descendants d'un <template> sont dans content, hors de querySelectorAll(root).
  const fallbackTemplate = root.querySelector('template[data-products-for="fallback"]');
  const availableFallbackIds = new Set(Array.from(fallbackTemplate?.content.querySelectorAll("[data-product-card]") || [])
    .filter(card => card.dataset.productId && card.dataset.productAvailable !== "false")
    .map(card => card.dataset.productId));
  if (availableFallbackIds.size < 2) {
    const stat = pick("[data-products-stat]");
    if (stat) {
      stat.querySelector("strong").textContent = availableFallbackIds.size === 1 ? "1" : "+";
      stat.querySelector("span").textContent = availableFallbackIds.size === 1
        ? "modèle de cage à découvrir" : "cages à découvrir";
    }
  }
  root.dataset.mcSissyInitialized = "true";
  let answers = Array(questions.length).fill(null);
  let step = 0;
  let currentResult = null;

  function renderQuestion() {
    const question = questions[step];
    pick("[data-progress-label]").textContent = `Question ${step + 1} sur ${questions.length}`;
    pick("[data-progress-fraction]").textContent = `${step + 1} / ${questions.length}`;
    pick("[data-progress]").value = step + 1;
    pick("[data-instruction]").textContent = step < 6
      ? "Une réponse par question. Vous pouvez passer cette question si vous hésitez."
      : "Choisissez la réponse qui se rapproche le plus de vos envies.";
    slot.innerHTML = `<fieldset><legend tabindex="-1">${escapeHtml(question.title)}</legend><div class="options-grid">${question.options.map(option => `<label class="option-card${option.discreet ? " option-card--other" : ""}"><input type="radio" name="answer" value="${escapeHtml(option.id)}"${answers[step] === option.id ? " checked" : ""}><span><strong>${escapeHtml(option.title)}</strong><small>${escapeHtml(option.detail)}</small></span></label>`).join("")}</div></fieldset>`;
    back.textContent = step ? "Question précédente" : "Retour à l’accueil";
    skip.hidden = step >= 6;
    next.textContent = step === 7 ? "Voir mon résultat" : "Continuer";
    error.hidden = true;
    slot.querySelector("legend").focus();
  }

  function openQuiz() {
    entry.hidden = true;
    resultView.hidden = true;
    quiz.hidden = false;
    renderQuestion();
    root.scrollIntoView({ block: "start", behavior: "auto" });
  }

  function showResult() {
    const result = calculateResult(answers);
    currentResult = result;
    quiz.hidden = true;
    resultView.hidden = false;
    resultContent.innerHTML = renderResultContent(result, imageURLs);
    pick("[data-radar]").innerHTML = renderRadar(result.scores);
    renderProductChooser(root, result);
    renderProducts(root, result);
    resultContent.querySelector("[data-result-title]").focus();
    root.scrollIntoView({ block: "start", behavior: "auto" });
  }

  start.addEventListener("click", openQuiz);
  form.addEventListener("change", event => {
    if (event.target.matches('input[name="answer"]')) {
      answers[step] = event.target.value;
      error.hidden = true;
    }
  });
  back.addEventListener("click", () => {
    if (step > 0) { step -= 1; renderQuestion(); }
    else { quiz.hidden = true; entry.hidden = false; start.focus(); }
  });
  skip.addEventListener("click", () => {
    if (step >= 6) return;
    answers[step] = null;
    step += 1;
    renderQuestion();
  });
  form.addEventListener("submit", event => {
    event.preventDefault();
    const checked = form.querySelector('input[name="answer"]:checked');
    if (!checked) {
      error.hidden = false;
      error.tabIndex = -1;
      error.focus();
      return;
    }
    answers[step] = checked.value;
    if (step < questions.length - 1) { step += 1; renderQuestion(); }
    else showResult();
  });
  restart.addEventListener("click", () => {
    answers = Array(questions.length).fill(null);
    step = 0;
    currentResult = null;
    openQuiz();
  });
  productChooser.addEventListener("click", event => {
    const button = event.target.closest("button[data-choose-product-profile]");
    if (!button || !productChooser.contains(button) || !currentResult) return;
    const key = button.dataset.chooseProductProfile;
    if (!productProfileChoices(currentResult).includes(key)) return;
    productChooser.querySelectorAll("button[data-choose-product-profile]").forEach(item => {
      item.setAttribute("aria-pressed", item === button ? "true" : "false");
    });
    renderProducts(root, currentResult, key);
    updateFirstStep(resultContent, currentResult, key);
  });
  resultContent.addEventListener("click", event => {
    const pisteButton = event.target.closest("button[data-piste]");
    const choice = resultContent.querySelector("[data-piste-choice]");
    if (!choice) return;
    if (pisteButton && resultContent.contains(pisteButton)) {
      const key = pisteButton.dataset.piste;
      if (!profiles[key]) return;
      choice.innerHTML = `<strong>Votre première piste à essayer : ${escapeHtml(displayName(key))}.</strong> Vous avez indiqué vouloir explorer ce rôle en premier ; les autres pistes restent possibles.`;
      choice.hidden = false;
      resultContent.querySelectorAll("button[data-piste]").forEach(button => {
        const selected = button === pisteButton;
        button.setAttribute("aria-pressed", selected ? "true" : "false");
        const badge = button.querySelector(".tie-card__badge");
        if (badge) badge.textContent = selected ? "Piste choisie" : "Piste à explorer";
      });
      if (currentResult?.kind === "many-pistes" && currentResult.leaders.includes(key)) {
        renderProducts(root, currentResult, key);
        updateFirstStep(resultContent, currentResult, key);
      }
    } else if (event.target.closest("[data-keep-pistes]")) {
      choice.textContent = "Vous pouvez garder toutes ces pistes et les explorer à votre rythme.";
      choice.hidden = false;
      resultContent.querySelectorAll("button[data-piste]").forEach(button => {
        button.setAttribute("aria-pressed", "false");
        const badge = button.querySelector(".tie-card__badge");
        if (badge) badge.textContent = "Piste à explorer";
      });
      if (currentResult?.kind === "many-pistes") {
        renderProducts(root, currentResult);
        updateFirstStep(resultContent, currentResult, "");
      }
    }
  });
}

function initAll(scope) {
  if (scope.matches?.("[data-mc-sissy-test]")) initQuiz(scope);
  scope.querySelectorAll?.("[data-mc-sissy-test]").forEach(initQuiz);
}

if (typeof document !== "undefined") {
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => initAll(document));
  } else {
    initAll(document);
  }
  document.addEventListener("shopify:section:load", event => initAll(event.target));
}
if (typeof module !== "undefined") {
  module.exports = { questions, profiles, calculateResult, renderResultContent, renderRadar,
    selectedProductCards, firstStepFor, updateFirstStep, initQuiz };
}
}());
